// Utility helper functions for ChatWidget

// Format phone number to +1 (XXX) XXX-XXXX
export function formatPhoneNumber(phone) {
    // Remove all non-digit characters
    let digits = phone.replace(/\D/g, '');

    // Handle 11 digits (with leading 1 for +1 country code)
    if (digits.length === 11 && digits.startsWith('1')) {
        digits = digits.substring(1); // Strip the leading 1
    }

    // Check if we have exactly 10 digits (North American format)
    if (digits.length === 10) {
        // Format as +1 (XXX) XXX-XXXX
        return `+1 (${digits.substring(0, 3)}) ${digits.substring(3, 6)}-${digits.substring(6, 10)}`;
    }

    // Return original if not 10 digits
    return phone;
}

// Format phone number in real-time as user types (handles partial input)
// Format as (XXX) XXX-XXXX - country code +1 is shown separately in the form UI
export function formatPhoneNumberRealTime(value) {
    // Remove all non-digit characters
    const digits = value.replace(/\D/g, '');

    // Format as user types without +1 prefix (shown separately in UI)
    if (digits.length === 0) {
        return '';
    } else if (digits.length <= 3) {
        return `(${digits}`;
    } else if (digits.length <= 6) {
        return `(${digits.substring(0, 3)}) ${digits.substring(3)}`;
    } else if (digits.length <= 10) {
        return `(${digits.substring(0, 3)}) ${digits.substring(3, 6)}-${digits.substring(6, 10)}`;
    } else {
        // Limit to 10 digits
        return `(${digits.substring(0, 3)}) ${digits.substring(3, 6)}-${digits.substring(6, 10)}`;
    }
}

// Validate phone number (must be exactly 10 digits for North American numbers)
export function validatePhoneNumber(phone) {
    // Remove all non-digit characters
    const digits = phone.replace(/\D/g, '');

    // Must be exactly 10 digits for North American numbers
    return digits.length === 10;
}

// Validate email address (RFC 5322 compliant, practical subset)
export function validateEmail(email) {
    // More robust email validation:
    // - Local part: alphanumeric, dots, hyphens, underscores, plus signs
    // - Cannot start or end with dot
    // - Cannot have consecutive dots
    // - Domain part: alphanumeric, dots, hyphens
    // - Must have at least one dot in domain for TLD
    const emailRegex = /^[a-zA-Z0-9_+\-]+([.][a-zA-Z0-9_+\-]+)*@[a-zA-Z0-9\-]+([.][a-zA-Z0-9\-]+)+$/;
    return emailRegex.test(email);
}

// Format timestamp to HH:MM
export function formatTime(timestamp) {
    const date = new Date(timestamp);
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
}
